export default __webpack_public_path__ + "static/media/logo-white.c0311648.svg";